<script setup>
import ChatList from './ChatList.vue';
import PopOverSearch from '../routes/dashboard/conversation/search/PopOverSearch.vue';

defineProps({
  showConversationList: { type: Boolean, default: true },
  conversationInbox: { type: [String, Number], default: 0 },
  label: { type: String, default: '' },
  teamId: { type: [String, Number], default: 0 },
  conversationType: { type: String, default: '' },
  foldersId: { type: [String, Number], default: 0 },
  isOnExpandedLayout: { type: Boolean, default: false },
  showPopOverSearch: { type: Boolean, default: false },
});

const emit = defineEmits(['conversationLoad', 'toggleConversationLayout', 'openSearch']);

const onConversationLoad = (conversation) => {
  emit('conversationLoad', conversation);
};

const toggleConversationLayout = () => {
  emit('toggleConversationLayout');
};

const onOpenSearch = () => {
  emit('openSearch');
};
</script>

<template>
  <div 
    class="h-full w-full bg-white dark:bg-slate-800 rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300 flex flex-col"
    style="overflow: visible;"
  >
    <!-- 1. Search Box -->
    <div v-if="showPopOverSearch" class="px-4 py-4 lg:py-3 border-b border-slate-200/30 dark:border-slate-600/30 bg-slate-50 dark:bg-slate-900">
      <PopOverSearch
        :is-on-expanded-layout="isOnExpandedLayout"
        class="w-4/5 xl:w-full mx-auto"
        @toggle-conversation-layout="toggleConversationLayout"
        @open-search="onOpenSearch"
      />
    </div>


    <!-- 3. ChatList with Header (All Conversations + Filter/Sort) -->
    <div class="flex-1 min-h-0" style="overflow: visible;">
      <ChatList
        :show-conversation-list="showConversationList"
        :show-chat-list-header="true"
        :conversation-inbox="conversationInbox"
        :label="label"
        :team-id="teamId"
        :conversation-type="conversationType"
        :folders-id="foldersId"
        :is-on-expanded-layout="isOnExpandedLayout"
        @conversation-load="onConversationLoad"
      />
    </div>
  </div>
</template>
